import { useCallback, useEffect, useState } from 'react';

import { useGenerateFormFM1 } from 'api/requests';
import { Base64FileData } from 'api/types/data';
import { downloadBase64File } from 'helpers';

import {
  FormFM1Currency,
  FormFM1FormType,
  MAX_FLOATING_POINTS,
} from '../forms/formFM1Form';

const initialValues: Partial<FormFM1FormType> = {
  thresholdValue: 50000,
  currency: {
    value: FormFM1Currency.USD,
    label: FormFM1Currency.USD,
  },
};

export const useFormFM1Form = () => {
  const [formFM1Data, setFormFM1Data] = useState<Base64FileData>();

  const [errorMessage, setErrorMessage] = useState<string>();
  const [isError, setIsError] = useState<boolean>(false);

  const {
    generateFormFM1,
    error,
    loading: submitLoading,
  } = useGenerateFormFM1();

  const onSubmit = useCallback(
    async (values: FormFM1FormType) => {
      if (values) {
        const res = await generateFormFM1(
          {
            file: values.files?.[0].file!,
            cnyKzt: Number(values.cnyKzt),
            eurKzt: Number(values.eurKzt),
            rubKzt: Number(values.rubKzt),
            usdKzt: Number(values.usdKzt),
            aedKzt: Number(values.aedKzt),
            thresholdValue: Number(values.thresholdValue),
            currency: values.currency.value,
            clients: values.clients.map((client) => client.value),
          },
          MAX_FLOATING_POINTS
        );
        if (res) {
          setFormFM1Data(res);
        }
      }
    },
    [generateFormFM1]
  );

  const reset = useCallback(() => {
    setFormFM1Data(undefined);
    setIsError(false);
  }, []);

  const onDownloadFile = useCallback(() => {
    if (formFM1Data) {
      downloadBase64File(formFM1Data, 'application/zip');
    }
  }, [formFM1Data]);

  useEffect(() => {
    if (error) {
      setErrorMessage(error.localizedDescription);
      setIsError(true);
    } else {
      setErrorMessage(undefined);
      setIsError(false);
    }
  }, [error]);

  return {
    onSubmit,
    reset,
    onDownloadFile,
    setIsError,
    onBack: reset,
    initialValues,
    errorMessage,
    isError,
    isSuccessGenerate: !!formFM1Data,
    submitLoading,
  };
};
